<template>
  <div v-if="post" class="page__post">
    <template v-if="type === 'video'">
      <PostVideo :post="post"/>
    </template>
    <template v-else-if="type === 'podcast'">
      <PostPodcast :post="post"/>
    </template>
    <template v-else>
      <PostNormal :post="post"/>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import PostNormal from './PostNormal/index.vue'
import PostVideo from './PostVideo/index.vue'
import PostPodcast from './PostPodcast/index.vue'

export default {
  name: 'Post',

  components: {
    PostNormal,
    PostVideo,
    PostPodcast
  },

  data () {
    return {
      id: 0,
      type: 'normal',
      post: null
    }
  },

  computed: {
    ...mapState(['pageData'])
  },

  beforeRouteEnter (to, from, next) {
    const { id } = to.query
    if (!id) {
      next({ name: 'Home' })
    } else {
      next()
    }
  },

  beforeRouteUpdate(to, from, next) {
    const { id } = to.query
    if (!id) {
      next({ name: 'Home' })
    } else {
      next()
    }
  },

  watch: {
    '$route.query': {
      immediate: true,
      handler () {
        const { type = 'normal', id } = this.$route.query
        this.type = type
        this.id = id
      }
    }
  },

  methods: {
    getType () {
      switch (this.post.post_type) {
        case 2:
          return 'video'
        case 4:
          return 'podcast'
        default:
          return 'normal'
      }
    },
    async fetchData () {
      try {
        const res = await this.$http({
          url: '/article/info/get',
          params: {
            id: this.id
          }
        })
        if (res.error) throw new Error(res.msg)
        this.post = res.data
        this.type = this.getType()
      } catch (error) {
        this.$toast({
          type: 'error',
          message: error.message
        })
      }
    }
  },

  created () {
    this.fetchData()
  }
}
</script>
